<div class="flex justify-between items-center">
  <div class="md:min-w-1/2 w-full">
    <app-stepper>
      <app-step icon="check" label="Search"></app-step>
      <app-step icon="columns-3" label="Compare" [active]="true"></app-step>
    </app-stepper>
  </div>

    <div class="flex items-center gap-2">
      @if (shareVisible()) {
        <app-dropdown variant="secondary" size="x-small" [disabled]="shareDisabled()" [title]="access.getTitle(['send_quote_via_text', 'send_quote_via_email', 'send_quote_via_print'])">
          <label class="flex items-center gap-1" id="compare-share-button">
            <app-icons width="14" class="inline-flex" icon="share-nodes"></app-icons>
            <span class="hidden md:block">Share</span>
          </label>

          @if (emailVisible()) {
            <app-dropdown-item [disabled]="emailDisabled()" [title]="access.getTitle('send_quote_via_email', 'Email')" (itemClick)="share('email')">
              <div class="flex items-center gap-1">
                <app-icons class="inline-flex" icon="envelope"></app-icons>
                Email
              </div>
            </app-dropdown-item>
          }

          @if (textVisible()) {
            <app-dropdown-item [disabled]="textDisabled()" [title]="access.getTitle('send_quote_via_text', 'Text')" (itemClick)="share('text')">
              <div class="flex items-center gap-1">
                <app-icons class="inline-flex" icon="mobile-screen-button"></app-icons>
                Text
              </div>
            </app-dropdown-item>
          }

          @if (printVisible()) {
            <app-dropdown-item [disabled]="printDisabled()" [title]="access.getTitle('send_quote_via_print', 'Print')" (itemClick)="share('print'); print()">
              <div class="flex items-center gap-1">
                <app-icons icon="print"></app-icons>
                Print
              </div>
            </app-dropdown-item>
          }
        </app-dropdown>
      }

      <app-link (click)="tourService.start('compare')" title="Show tour" class="hidden lg:block">
        <app-icons icon="info-circle" width="20"></app-icons>
      </app-link>

      @if (settingsVisible()) {
        <app-link href="settings" [extras]="{queryParams: {returnTo: 'compare'}}" [disabled]="settingsDisabled()" [title]="access.getTitle('edit_settings', 'Open settings')" class="hidden lg:block">
          <app-icons icon="gear" width="20"></app-icons>
        </app-link>
      }
    </div>
</div>
